import React from 'react';
import { BackgroundColorEnum } from '@/enums/styling';
import { getTailwindClassByEnum } from '@/utils/cssHelpers';
import Image from '@/components/elements/image';

function BlogHeader({ elementProps, backgroundColor, metadataImage, pageContext }) {
	return (
		<header
			{...elementProps}
			className={`flex justify-center w-full pt-10 lg:pt-14 h-20 sm:h-24 md:h-32 lg:h-44 2xl:h-64 relative  ${
				getTailwindClassByEnum(BackgroundColorEnum, backgroundColor) || 'bg-tree-poppy'
			}`}
		>
			<div className="mb-10 rounded-lg overflow-hidden flex justify-center border-white border-4 w-[160px] sm:w-[300px] lg:w-[440px] 2xl:w-[660px] 3xl:w-[700px] absolute">
				{metadataImage ? (
					<Image
						src={metadataImage.filename}
						alt={metadataImage.alt || ''}
						title={metadataImage.title}
						pageContext={pageContext}
						width="w-full"
					/>
				) : null}
			</div>
		</header>
	);
}

export default BlogHeader;
